module.exports = __webpack_public_path__ + "static/media/Shape.0c0e58ab.svg";